(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animation-media-scroll3"] && !Shopify.designMode) return;
  try {
    
(function() {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  if (windowWidth < 1024) return;

  var timer = null
  function checkDom(dom, callback) {
    if(dom) {
      callback();
      if(!timer) {
        clearTimeout(timer);
      }
    } else {
      timer = setTimeout(checkDom, 0);
    }
  }
  
  const sections = document.querySelectorAll('.mz-media-scroll1');
  const left = document.querySelector('.mz-header__wrapper>.mz-container .mz-header__logo').getBoundingClientRect().left;
  const mediaWidth = (windowWidth - left * 2) / 2 - 15;
  sections.forEach(v => {
    const container = v.querySelector('.media-scroll-container');
    const fixed = v.querySelector('.fixed-container');
    const blocks = v.querySelectorAll('.media-block');
    const heading = v.querySelector('.top-heading');
    const topMedia = v.querySelector('.media-top .top-container');
    const layout = topMedia.getAttribute('data-layout');
    const topText = v.querySelector('.media-top .top-media-texts');
    let height = windowHeight * (blocks.length + 2);
    if (blocks.length === 0) {
      height = windowHeight * (blocks.length + 3);
    }
    container.style.height = `${height}px`;
    if (layout === 'txt_right') {
      topText.style.right = `${left}px`;
    } else {
      topText.style.left = `${left}px`;
    }

    blocks.forEach(v => {
      v.style.left = `${left}px`;
      v.style.width = `calc(100vw - ${left * 2}px)`;
      v.querySelector('.media').style.width = `${mediaWidth}px`;
      v.querySelector('.media').style.height = `${mediaWidth * 2 / 3}px`;
      v.querySelector('.text-block').style.width = `${mediaWidth}px`;
    });

    let screenCount = blocks.length + 2;
    if (blocks.length !== 0) {
      screenCount = blocks.length + 1;
    }

    window.addEventListener('scroll', () => {
      const vTop = container.getBoundingClientRect().top;
      const scrolled = - vTop / (height - windowHeight);
      let split = 1 / (blocks.length + 2);
      if (blocks.length === 0) {
        split = 1 / (blocks.length + 3);
      }
      if (vTop < 50 && vTop > (-windowHeight -height)) {
        fixed.classList.add('fixed');
        fixed.style.transform = `translate(0px,0px)`;

        // heading show up
        const onePercent = 1 / screenCount;
        if (vTop > (-windowHeight - 100)) {
          topMedia.style.width = '100vw';
          topMedia.style.height = '100vh';
          heading.style.top = `${100 - scrolled / onePercent * 100 - 15}vh`;
          if (layout === 'txt_right') {
            topMedia.style.left = '0';  
          } else {
            topMedia.style.right = '0';
          }
          topMedia.style.borderRadius = '0';
          topText.classList.remove('active');
        }
        // topImage smaller
        if (vTop < -windowHeight && vTop > -windowHeight * 2) {
          const TopImageMedia = v.querySelector('.top-media-texts');
          const scrollPercent = 1 - (scrolled - onePercent) / onePercent;
          const width = 100 - (scrolled - onePercent) / onePercent * 100;
          // TopImageMedia.style.marginRight = `${left - 20}px`;
          TopImageMedia.style.width = `${mediaWidth}px`;
          if ((1 - scrollPercent) * 2 < 0.62) {
            topMedia.style.width = '100vw';
            topMedia.style.height = '100vh';
            if (layout === 'txt_right') {
              topMedia.style.left = '0';  
            } else {
              topMedia.style.right = '0';
            }
            topMedia.style.borderRadius = '0';
            topText.classList.remove('active');
          } else if ((1 - scrollPercent) * 2 < 1) {
            topMedia.style.width = `${width}vw`;
            topMedia.style.height = `${60 * scrollPercent}vw`;
            if (layout === 'txt_right') {
              topMedia.style.left = `${left * (1 - scrollPercent) * 2}px`;
            } else {
              topMedia.style.right = `${left * (1 - scrollPercent) * 2}px`;
            }
            topMedia.style.borderRadius = `${16 * scrollPercent}px`;
          } else if ((1 - scrollPercent) * 2 >= 1) {
            topMedia.style.width = mediaWidth + 'px';
            topMedia.style.height = mediaWidth * 2 / 3 + 'px';
            if (layout === 'txt_right') {
              topMedia.style.left = `${left}px`;
            } else {
              topMedia.style.right = `${left}px`;
            }
            topMedia.style.borderRadius = '16px';
            topText.classList.add('active');
          }
        }

        // image switch
        if (vTop < -windowHeight * 2) {
          topMedia.style.opacity = 0;
          topText.classList.remove('active');
          blocks.forEach(v => {
            v.style.opacity = 0;
            v.classList.remove('active');
          });
          console.log(vTop, -windowHeight * 2, height);
          if (vTop > (windowHeight / 2 - height)) {
            blocks[Math.floor(scrolled / split) - 3].style.opacity = 1;
            blocks[Math.floor(scrolled / split) - 3].classList.add('active');    
          }
        } else {
          blocks.forEach(v => {
            v.style.opacity = 0;
            v.classList.remove('active');
          });
          topMedia.style.opacity = 1;
        }

        if (vTop <= (windowHeight - height)) {
          fixed.classList.remove('fixed');
          fixed.style.transform = `translate(0px,${windowHeight * (blocks.length + 1)}px)`;
          topMedia.style.opacity = 0;
        }
        
      } else {
        fixed.classList.remove('fixed');
        if (vTop > 50) {
          fixed.style.transform = `translate(0px,0px)`;
        }
        if (vTop <= (windowHeight -height)) {
          if (blocks.length === 0) {
            fixed.style.transform = `translate(0px,${windowHeight * (blocks.length + 2)}px)`;
          } else {
            fixed.style.transform = `translate(0px,${windowHeight * (blocks.length + 1)}px)`;
          }
        }
      }
    });
  });
})();  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animation-vertical-switch"] && !Shopify.designMode) return;
  try {
    
(function() {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  var timer = null
  function checkDom(dom, callback) {
    if(dom) {
      callback();
      if(!timer) {
        clearTimeout(timer);
      }
    } else {
      timer = setTimeout(checkDom, 0);
    }
  }
  
  const sections = document.querySelectorAll('.mz-vertical-switch');
  sections.forEach(v => {
    const container = v.querySelector('.animation-container');
    const fixed = v.querySelector('.fixed-container');
    const blocks = v.querySelectorAll('.media-block');
    const height = windowHeight * 2;
    container.style.height = `${height}px`;

    window.addEventListener('scroll', () => {
      const vTop = container.getBoundingClientRect().top;
      const scrolled = 100 + vTop / windowHeight * 100;
      if (vTop <= 0) {
        fixed.classList.add('fixed');
        fixed.style.transform = `translate(0px,0px)`;

        blocks[0].style.height = scrolled + 'vh';

        if (vTop <= -windowHeight) {
          fixed.classList.remove('fixed');
          fixed.style.transform = `translate(0px,${windowHeight}px)`; 
        }
      } else {
        fixed.classList.remove('fixed');
        fixed.style.transform = `translate(0px,0px)`;
      }
    });
  });
})();  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-slideshow"] && !Shopify.designMode) return;
  try {
    
(function() {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  
  if (windowWidth >= 1024) {
    var timer = null
    function checkDom(dom, callback) {
      if(dom) {
        callback();
        if(!timer) {
          clearTimeout(timer);
        }
      } else {
        timer = setTimeout(checkDom, 0);
      }
    }
    const pageSide = document.querySelector('.mz-header__logo').offsetLeft;
    const slides = document.querySelectorAll('.mz-vertical-slideshow');
    slides.forEach(v => {
      const container = v.querySelector('.vertical-slideshow');
      const gap = container.getAttribute('data-gap');
      const images = v.querySelectorAll('.slide-image-pc');
      const medias = v.querySelectorAll('.media-container');
      const height = windowHeight * images.length - (1 - container.getAttribute('data-height') * 1 / 100) * windowHeight + 220;
      const transform = height - container.offsetHeight - 160;
      v.querySelector('.mz-section-inner').style.height = `${height + 30}px`;
      
      const left = document.querySelector('.mz-header__wrapper>.mz-container .mz-header__logo').getBoundingClientRect().left;
      // const imageWidth = (1 - container.getAttribute('data-width') * 1 / 100) * windowWidth;
      const imageWidth = images[0].getBoundingClientRect().width;
      console.log(windowWidth, imageWidth, windowWidth - imageWidth - left * 2 - gap * 1 - 15)
      const progress = v.querySelector('.progress-bar');
      progress.style.width = `${windowWidth - imageWidth - left * 2 - gap * 1 - 15}px`;
      const progressHeight = progress.offsetHeight + 40;
      const progressActive = v.querySelector('.progress-bar .active-line');

      const stylePags = v.querySelectorAll('.style-pagination div');
      const titles = v.querySelectorAll('.custom-pagination-title');
      const contents = v.querySelectorAll('.custom-pagination-content');
      const split = 1 / titles.length;

      const currentPos = - v.getBoundingClientRect().top / (height - windowHeight);
      if (v.getBoundingClientRect().top < 50 && v.getBoundingClientRect().top > (windowHeight -height)) {
        if (stylePags && stylePags.length !== 0) {
          stylePags.forEach(v => {
            v.classList.remove('active');
          });
          if (stylePags[Math.floor(currentPos / split)]) stylePags[Math.floor(currentPos / split)].classList.add('active');
        }
        titles.forEach(v => {
          v.classList.remove('active');
        });
        if (titles[Math.floor(currentPos / split)]) titles[Math.floor(currentPos / split)].classList.add('active');
        contents.forEach(v => {
          v.classList.remove('active');
        });
        if (contents[Math.floor(currentPos / split)]) contents[Math.floor(currentPos / split)].classList.add('active');

        medias.forEach(v => {
          v.style.opacity = 0;
        });
        if (medias[Math.floor(currentPos / split)]) medias[Math.floor(currentPos / split)].style.opacity = 1;
      }
      
      window.addEventListener('scroll', () => {
        const scrolled = - v.getBoundingClientRect().top / (height - windowHeight);
        if (v.getBoundingClientRect().top < 50 && v.getBoundingClientRect().top > (windowHeight -height)) {
          progressActive.style.height = `${progressHeight * scrolled}px`;
          if (stylePags && stylePags.length !== 0) {
            stylePags.forEach(v => {
              v.classList.remove('active');
            });
            stylePags[Math.floor(scrolled / split)].classList.add('active');
          }
          titles.forEach(v => {
            v.classList.remove('active');
          });
          titles[Math.floor(scrolled / split)].classList.add('active');
          contents.forEach(v => {
            v.classList.remove('active');
          });
          contents[Math.floor(scrolled / split)].classList.add('active');
          medias.forEach(v => {
            v.style.opacity = 0;
            if (v.querySelector('.slide-content')) {
              v.querySelector('.slide-content').style.opacity = 0;
            }
          });
          medias[Math.floor(scrolled / split)].style.opacity = 1;

          const mediaImage = medias[Math.floor(scrolled / split)].querySelector('.image-pc');
          const mediaVideo = medias[Math.floor(scrolled / split)].querySelector('video');
          const mediaContent = medias[Math.floor(scrolled / split)].querySelector('.slide-content');

          if (mediaContent) mediaContent.style.opacity = 1;
          
          const percent = (scrolled - Math.floor(scrolled / split) * (1 / medias.length)) / (1 / medias.length);
          if (percent < 0.5) {
            if (mediaContent) mediaContent.style.transform = `translate(0, -${percent * 100}%)`;
            if (mediaImage) {
              mediaImage.style.transform = `translate3D(0px, -${percent * 100 + 10}px, 0px)`;
            }
            if (mediaVideo) {
              mediaVideo.style.transform = `translate3D(0px, -${percent * 100 + 10}px, 0px)`;
            }
          }
          
          v.classList.add('fixed');
          container.style.transform = `translate(-50%,0px)`;
        } else {
          if (v.getBoundingClientRect().top > 50) {
            container.style.transform = `translate(-50%,0px)`;
            progressActive.style.height = `0px`;
          }
          if (v.getBoundingClientRect().top < (windowHeight -height)) {
            container.style.transform = `translate(-50%,${transform}px)`;
            progressActive.style.height = `${progressHeight}px`;
          }
          v.classList.remove('fixed');
        }
      });
    });  
  }
  
})();  

  } catch(e) { console.error(e); }
})();
})();
